import React from 'react';
import { useModalDismiss } from '../hooks/useModalDismiss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimes } from '@fortawesome/free-solid-svg-icons';

const SuccessModal = ({ 
  isOpen, 
  onClose, 
  title = "Succès",
  message, 
  duration = 3000
}) => {
  React.useEffect(() => {
    if (isOpen && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
        // Scroll to top when modal auto-closes
        window.scrollTo(0, 0);
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isOpen, duration, onClose]);

  const handleClose = () => {
    onClose();
    // Scroll to top when modal is manually closed
    window.scrollTo(0, 0);
  };

  const dismiss = useModalDismiss(handleClose, { enabled: isOpen });

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 py-8">
        {/* Backdrop */}
        <div 
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          {...dismiss}
        ></div>

        {/* Modal */}
        <div className="relative inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
          <div className="flex items-start">
            <div className="flex-shrink-0 flex items-center justify-center w-12 h-12 mx-auto rounded-full bg-green-100">
              <FontAwesomeIcon 
                icon={faCheckCircle} 
                className="w-6 h-6 text-green-600" 
                aria-hidden="true" 
              />
            </div>
            <div className="ml-4 flex-1">
              <h3 className="text-lg font-semibold leading-6 text-gray-900">
                {title}
              </h3>
              <div className="mt-2">
                <p className="text-sm text-gray-600">
                  {message}
                </p>
              </div>
            </div>
            <button
              onClick={handleClose}
              className="flex-shrink-0 ml-4 p-1 rounded-full text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-red-500"
            >
              <FontAwesomeIcon icon={faTimes} className="w-5 h-5" />
            </button>
          </div>
          
          {/* Progress bar for auto-dismiss */}
          {duration > 0 && (
            <div className="mt-4">
              <div className="w-full bg-gray-200 rounded-full h-1">
                <div 
                  className="bg-green-600 h-1 rounded-full transition-all ease-linear"
                  style={{
                    width: '100%',
                    animation: `progress ${duration}ms linear forwards`
                  }}
                ></div>
              </div>
            </div>
          )}
        </div>
      </div>
      
      <style jsx>{`
        @keyframes progress {
          from { width: 100%; }
          to { width: 0%; }
        }
      `}</style>
    </div>
  );
};

export default SuccessModal;
